<template>
  <div>
    <div class="inline-wrapper bettinfo-date">
      <el-radio-group v-model="fastData" @change="fastDataChange">
        <el-radio-button label="7 days" :class="{ 'is-active': firstActive }"></el-radio-button>
        <el-radio-button label="1 Month"></el-radio-button>
        <el-radio-button label="3 Month"></el-radio-button>
      </el-radio-group>
      <el-date-picker
        style="width:140px;"
        class="bet-date-picker"
        v-model="freeDate"
        type="date"
        placeholder="Start Time"
        :picker-options="pickerOptions"
        @change="dataTimeChange"
        :clearable="false"
        :editable="false"
      ></el-date-picker>
      <div
        style="line-height: 37px;
    margin-left: 6px;
    color: #606266;"
      >- {{ formatDate(nowDate) }}</div>
      <div class="observe">
        <el-button
          type="primary"
          class="lebel-risk-export-btn"
          @click="isShow('Batch Observe',2)"
        >Observe</el-button>
      </div>
    </div>
    <div>
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        v-loading="loading"
        @selection-change="handleSelectionChange"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column type="selection" :selectable="checkSelectable" align="center" width="36"></el-table-column>
        <el-table-column label="IP" prop="ip" min-width="224">
          <template v-slot="{ row }">
            <div class="ip-name" :class="{ 're-ip-name': row.ipStatus == 3 }">{{ row.ip }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Region" prop="region" min-width="279"></el-table-column>
        <el-table-column label="Use Type" prop="useTypes" min-width="222">
          <template v-slot="{ row }">
            <div class="use-types">
              <span v-for="(item, index) in row.useTypes" :key="index">
                {{ item == 3 ? "Bet" : "Login" }}
                <i>、</i>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="First Use Time" sortable prop="firstTime" min-width="223">
          <template v-slot="{ row }">
            <div v-if="row.firstTime">{{ formatUtc(row.firstTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Last Use Time" prop="lastTime" sortable min-width="223">
          <template v-slot="{ row }">
            <div v-if="row.lastTime">{{ formatUtc(row.lastTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Related Member" sortable prop="users" min-width="223">
          <template v-slot="{ row }">
            <div v-if="row.ipStatus == 2" class="users">-</div>
            <div v-else class="users" @click="handleChange(row.ip)">{{ row.users }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrapper inline-wrapper">
      <el-pagination
        class="inline-right"
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.size"
        :page-sizes="[50, 100, 200]"
        @current-change="changePage"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <dia ref="dialogDom" class="label-dialog">
      <!-- 修改用户备注 -->
      <div v-if="num == 2">
        <el-form label-width="80px" :label-position="num === 2 ? 'top' : 'left'">
          <el-form-item>
            <div class="remark-warp">
              <div class="title">Remark</div>
              <el-input
                type="textarea"
                :rows="14"
                maxlength="240"
                show-word-limit
                placeholder="Input"
                v-model="observeQueryData.remark"
                resize="none"
              />
            </div>
          </el-form-item>
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button class="search-btn" @click="handleViewAdd()" v-if="num == 2">Confirm</el-button>
          <el-button class="clear-btn" @click="closeObserve()">Cancel</el-button>
        </div>
      </div>
      <div v-else>
        <el-table
          ref="table"
          :data="itemList"
          height="500"
          v-loading="loadingItem"
          header-row-class-name="table-header-row"
          border
        >
          <template slot="empty">
            <Empty />
          </template>
          <el-table-column label="User ID" prop="userId" min-width="15%">
            <template v-slot="{ row }">
              <div
                v-if="row.userId"
                @click="handleViewDetail(row)"
                style="text-decoration:underline;cursor: pointer;"
              >{{ row.userId }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Channel" prop="merchantName" min-width="17%"></el-table-column>
          <el-table-column label="Level" prop="userLevel" min-width="15%">
            <template v-slot="{ row }">
              <div v-if="row.userLevel">{{ formatUserLevel(row.userLevel) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Limit" prop="userLimit" min-width="17%">
            <template v-slot="{ row }">
              <div v-if="row.userLimitName">{{ row.userLimitName }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Sports(30days)" min-width="17%" :show-overflow-tooltip="true">
            <template v-slot="{ row }">{{ getDataSport(row.betSports) }}</template>
          </el-table-column>
          <el-table-column label="Settled Stake(30days)" prop="stake" sortable min-width="26%">
            <template v-slot="{ row }">
              <div>{{ Number(row.stake) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="PL(30days)" prop="profit" sortable min-width="20%">
            <template v-slot="{ row }">
              <div>{{ Number(row.profit) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="PL%(30days)" prop="lastUseType" sortable min-width="15%">
            <template v-slot="{ row }">
              <div
                v-if="Number(row.profit) > 0"
              >{{ ((Number(row.profit) / Number(row.stake)) * 100).toFixed(2) }}%</div>
              <div v-else>0</div>
            </template>
          </el-table-column>
          <el-table-column label="Last Use Time" sortable prop="lastTime" min-width="18%">
            <template v-slot="{ row }">
              <div v-if="row.lastTime">{{ formatUtc(row.lastTime) }}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wrapper inline-wrapper">
          <el-pagination
            class="inline-right"
            :total="totalAert"
            :current-page="queryAlert.current"
            :page-size="queryAlert.size"
            :page-sizes="[50, 100, 200]"
            @current-change="changeAlertPage"
            @size-change="handleSizeAlertChange"
            layout="total, sizes, prev, pager, next, jumper"
          ></el-pagination>
        </div>
        <div class="dialog-footer table-search-part" style="padding-top: 20px;">
          <el-button class="clear-btn" @click="Close()">Cancel</el-button>
        </div>
      </div>
    </dia>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import dia from "@/components/dialog/index";
import Empty from "@/components/empty/index";
import { getIpHistory, getIpItemInfo } from "@/api/memberDetail";
import { getRiskLevel, getLevelList } from "@/api/member";
import { getTcsSportList } from "@/api/memberDetail";
import { createIpManagement } from "@/api/ip";
export default {
  name: "RiskDetail",
  components: {
    Empty,
    dia
  },
  props: {
    handleCheckHistoryStatus: {
      type: Boolean
    },
    handleCheckUserInfoStatus: {
      type: Boolean
    }
  },
  data() {
    return {
      list: [],
      num: "",
      itemList: [],
      total: 0,
      fastData: "",
      freeDate: "",
      rowIp: "",
      nowDate: Date.now(),
      form: {},
      firstActive: false,
      loading: false,
      loadingItem: false,
      queryData: {
        beginTime: "",
        current: 1,
        size: 50
      },
      observeQueryData: {
        managementType: 1,
        ips: [],
        remark: ""
      },
      totalAert: 0,
      queryAlert: {
        current: 1,
        size: 50
      },
      multipleSelection: [],
      sportList: [],
      levelList: [],
      tableHeight: window.innerHeight,
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() > Date.now();
        }
      }
    };
  },
  watch: {
    handleCheckHistoryStatus(val) {
      if (val) {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 + 150;
        });
      } else {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 - 150;
        });
      }
    },
    handleCheckUserInfoStatus(val) {
      if (val) {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 + 115;
        });
      } else {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 - 115;
        });
      }
    }
  },
  methods: {
    async getSportList() {
      try {
        const res = await getTcsSportList({ matchType: '' });
        const data = res.data || {};
        this.sportList = data || [];
      } catch (error) {
        this.sportList = [];
      }
    },
    checkSelectable(row) {
      return row.ipStatus !== 3 && row.ipStatus !== 2;
    },
    async getLevelList() {
      const res = await getLevelList({});
      let data = res.data || [];
      this.levelList = data;
    },
    async getList() {
      this.queryData.userId = this.$route.query.userId;
      this.loading = true;
      try {
        const res = await getIpHistory(this.queryData);
        const data = res.data || {};
        this.list = data.records || [];
        this.total = Number(data.total);
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    async getItemList() {
      this.loadingItem = true;
      try {
        const res = await getIpItemInfo({
          ip: this.rowIp,
          current: this.queryAlert.current,
          size: this.queryAlert.size
        });
        const data = res.data.records || {};
        this.itemList = data || [];
        this.loadingItem = false;
        this.totalAert = Number(res.data.total);
      } catch (error) {
        this.itemList = [];
        this.loadingItem = false;
      }
    },
    // 获取运动字符串
    getDataSport(row) {
      let sportIds = row ? row : [];
      let str = "";
      this.sportList.map(item => {
        if (sportIds.includes(Number(item.code))) {
          str += item.value;
          str += "、";
        }
      });
      return str.slice(0, -1);
    },
    // 表格选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    isShow(title, val) {
      this.num = val;
      if (this.multipleSelection.length > 0) {
        this.observeQueryData.ips = Object.values(this.multipleSelection).map(
          el => el.ip
        );
        this.observeQueryData.remark = "";
        this.title = title;
        this.$refs["dialogDom"].isShowDia(this.title, true, "323px");
      } else {
        this.$message({ message: "Must checked one", type: "warning" });
      }
    },
    // 添加
    async handleViewAdd() {
      if (!this.observeQueryData.ips) {
        this.$message({
          message: "The IP can not be empty",
          type: "warning"
        });
        return false;
      }
      try {
        const res = await createIpManagement(this.observeQueryData);
        if (res.success) {
          this.$message({
            message: "add success",
            type: "success"
          });
          this.getList();
        } else {
          this.$message({
            message: res.message,
            type: "warning",
            duration: 30000,
            showClose: true
          });
        }
        this.closeObserve();
      } catch {}
    },
    // 查看详情
    handleViewDetail(data) {
      if (data.userId) {
        this.Close();
        this.$router.push({
          path: "/member/detail",
          query: { userId: data.userId }
        });
      }
    },
    getArray(data) {
      return Object.keys(data).map(el => {
        return {
          id: el,
          name: data[el]
        };
      });
    },
    fastDataChange(time) {
      this.firstActive = false;
      let d = [];
      if (time === "7 days") {
        d = [
          new Date(new Date().toLocaleDateString()).getTime() -
            6 * 24 * 60 * 60 * 1000,
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ];
      }
      if (time === "1 Month") {
        d = [
          new Date(new Date().toLocaleDateString()).getTime() -
            30 * 24 * 60 * 60 * 1000,
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ];
      }
      if (time === "3 Month") {
        d = [
          new Date(new Date().toLocaleDateString()).getTime() -
            90 * 24 * 60 * 60 * 1000,
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ];
      }
      this.queryData.beginTime = d[0];
      //this.queryData.loginEndTime = d[1];
      this.freeDate = d[0];
      this.getList();
    },
    dataTimeChange(e) {
      this.firstActive = false;
      //this.queryData.beginTime = startTime;
      //this.queryData.loginEndTime = endTime;
      const start = this.$moment(e)
        .startOf("day")
        .format("x"); //  当月第一天时间
      this.queryData.beginTime = start;

      this.fastData = "";
      this.queryData.current = 1;
      this.getList();
    },
    closeObserve() {
      this.observeQueryData.ips = [];
      this.observeQueryData.remark = "";
      this.$refs["dialogDom"].isShowDia(this.title, false, "323px");
    },
    handleChange(data) {
      this.num = "";
      this.title = "Related Member";
      this.rowIp = data;
      this.$refs["dialogDom"].isShowDia(this.title, true, "1400px");
      this.getItemList();
    },
    Close() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "1400px");
    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.size = e;
      this.queryData.current = 1;
      this.getList();
    },
    // 分页
    changeAlertPage(e) {
      this.queryAlert.current = e;
      this.getItemList();
    },
    // 列表显示条目
    handleSizeAlertChange(e) {
      this.queryAlert.size = e;
      this.queryAlert.current = 1;
      this.getItemList();
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    formatDate(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD");
    },
    formatOddsLevel(val) {
      if (val == 1) {
        return "A";
      } else if (val == 2) {
        return "B";
      } else if (val == 3) {
        return "C";
      } else if (val == 4) {
        return "D";
      } else if (val == 5) {
        return "E";
      }
    },
    formatUserLevel(val) {
      let name = "";
      this.levelList.map(item => {
        if (item.id == val) {
          name = item.name;
        }
      });
      return name;
    }
  },
  mounted() {
    let d = [];
    d = [
      new Date(new Date().toLocaleDateString()).getTime() -
        6 * 24 * 60 * 60 * 1000,
      new Date(new Date().toLocaleDateString()).getTime() +
        24 * 60 * 60 * 1000 -
        1
    ];
    this.queryData.beginTime = d[0];
    //this.queryData.loginEndTime = d[1];
    this.freeDate = d[0];
    this.firstActive = true;
    this.getSportList();
    this.getLevelList();
    this.getList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  }
};
</script>

<style lang="scss" scoped>
.el-dialog .el-table thead th {
  color: #fff !important;
  background: #2f4162 !important;
}
.observe {
  display: inline-block;
  margin-left: 20px;
  height: 37px;
  line-height: 37px;
}
.bettinfo-date {
  font-size: 12px;
  margin: 0 0 15px 0;
}
.ip-name {
  color: #0184b8;
  font-weight: 700;
}
.re-ip-name {
  color: #e1554f;
}
.use-types {
  span {
    &:last-child {
      i {
        display: none;
      }
    }
  }
}
.users {
  color: #0184b8;
  cursor: pointer;
}
.remark-warp {
  .title {
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    color: #333333;
    margin-bottom: 5px;
  }

  /deep/.el-textarea__inner {
    border: 1px solid #ebedf3 !important;
    border-radius: 5px;
    padding: 8px 7px;
  }
}
</style>
<style lang="scss">
.el-dialog .el-table thead th {
  color: #fff !important;
  background: #2f4162 !important;
}
</style>
